import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

import MechanicalWorkshopRepository from '@/shared/http/repositories/configuration/mechanicalworkshop'
import MechanicalWorkshopModel from '@/shared/models/configuration/mechanicalworkshopmodel'
import MechanicalWorkshopForms from './mechanicalworkshop-form'
import MechanicalWorkshopBudget from './budget/mechanicalworkshopbudget.vue'

import ExpertMixin from '@/store/module/expert/mixin.js'

import StateRepository from '@/shared/http/repositories/geo/state'
import CityRepository from '@/shared/http/repositories/geo/city'

import InsuranceMixin from '@/store/module/insurance/mixin.js'
import { JWTService } from '@/shared/services/jwt'

export default {
  name: 'MechanicalWorkshop',
  mixins: [
    ActionsForm,
    InsuranceMixin,
    ExpertMixin
  ],
  data () {
    return {
      data: MechanicalWorkshopModel,
      form: MechanicalWorkshopForms,
      tabIndex: 0,
      workshopid: 0,
      companyID: 0,
      status: '',
      accountUserNameUpdate: '',
      dateUpdate: '',
      AccountName: decodeURIComponent(escape(JWTService.GetTokenPayload().Name)),
      type: 0,
      search: ''
    }
  },
  components: {
    MechanicalWorkshopBudget
  },
  mounted () {
    this.onLoadAllState()
    this.getAllInsuranceByArea(process.env.AreaAutos)
    this.workshopid = 0
    this.companyID = 0
    this.status = ''
    this.accountUserNameUpdate = ''
    this.dateUpdate = ''
    this.type = 0
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    },
    getAllInsurer: function () {
      var result = []
      if ((this.insurances) && (this.insurances.count) > 0) {
        var data = this.insurances.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.insurance.options = result
      }
      return result
    },
    getAllExpert: function () {
      var result = []
      if ((this.experts) && (this.experts.count) > 0) {
        var data = this.experts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.formBudget.nameBudget.options = result
      }
      return result
    }
  },
  methods: {
    onLoad () {
      this.getAllMechanical()
      this.getAllExpertByArea(process.env.AreaAutos)
    },
    getAllMechanical () {
      MechanicalWorkshopRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
          console.log(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      // --> Set manual
      this.form.stateID.value = obj.city.stateID
      this.onChangeState()

      var self = this
      this.companyID = obj.companyID
      this.workshopid = obj.id
      this.dateUpdate = obj.dateUpdate
      this.accountUserNameUpdate = obj.accountUserNameUpdate
      this.status = obj.status
      this.$refs.MechanicalWorkshopBudget.workshopid = obj.id
      setTimeout(function (e) {
        self.form.cityID.value = obj.cityID
      }, 1000)
      this.tabIndex = 0
      loading.pop()
    },
    onCreate () {
      loading.push()
      MechanicalWorkshopRepository.Create(this.data)
        .then((response) => {
          if (response.status === 200 && response.data.code === -406) {
            toast.warning(this.$lang.MechanicalWorkshop.Alert.MechanicalWorkshopAlreadyExists)
          } else {
            this.onResult(response)
          }
        })
        .catch((err) => {
          this.onException(err)
        })
      loading.pop()
    },
    onUpdate () {
      loading.push()
      MechanicalWorkshopRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      MechanicalWorkshopRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllState () {
      loading.push()
      StateRepository.GetAll()
        .then((response) => {
          this.form.stateID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllCity (id) {
      this.form.cityID.options = []
      if (id) {
        loading.push()
        CityRepository.GetAllByStateID(id)
          .then((response) => {
            this.form.cityID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onChangeState () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllCity(self.form.stateID.value)
      }, 500)
    },
    onSearch () {
      if (this.search && this.search.trim().length >= 3) {
        MechanicalWorkshopRepository.GetAllByName(this.search)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onLoadAllBudget () {
      this.$refs.MechanicalWorkshopBudget.onLoad()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/mechanicalworkshop/mechanicalworkshop.js